import BaseProxy from "../../base-proxy";

/**
 * @class GetCompanyUserByQuestionnaireTokenProxy
 * @description Class used for retrieving company users associated with an invitation token
 * @author Justine Paul B. Guiao
 * @version 1.0
 * @since January 9, 2019
 */
export default class GetCompanyUserByQuestionnaireTokenProxy {
  /**
   * @async
   * @function getUser
   * @param input - Input parameter instance.
   * @param {String} input.questionnaireToken - Questionnaire token.
   */
  async getUser(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/company-users/questionnaire-token/${input.questionnaireToken}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
